import React, { useState, useEffect } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Divider, Typography } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { editCourse } from 'services/course/editCourse'; // You can replace this with an UpdateCourse API if needed

const EditCourseDialogue = ({ open, onClose, courseData = {}, title }) => {
  const [courseName, setCourseName] = useState('');
  const [postureCount, setPostureCount] = useState('');
  const [difficulty, setDifficulty] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState('');
  const [sequenceType, setSequenceType] = useState('');

  const queryClient = useQueryClient();

  useEffect(() => {
    if (courseData) {
      setCourseName(courseData.courseName || '');
      setPostureCount(courseData.asanaCount || '');
      setDifficulty(courseData.difficulty || '');
      setCategory(courseData.category || '');
      setDescription(courseData.description || '');

      // ✅ Parse tags safely
      try {
        const parsedTags = typeof courseData.tags === 'string' ? JSON.parse(courseData.tags) : courseData.tags || [];
        setTags(parsedTags.join(', '));
      } catch (e) {
        setTags('');
      }

      setSequenceType(courseData.sequenceType || '');
    }
  }, [courseData]);

  const { mutate, isLoading } = useMutation({
    mutationFn: editCourse, // You can replace with UpdateCourse
    onSuccess: (res) => {
      toast.success(res?.data?.message || 'Updated successfully!');
      queryClient.invalidateQueries(['allcourses']);
      onClose();
    },
    onError: (err) => {
      toast.error('Error updating course.');
      console.error(err);
    }
  });

  const handleSubmit = () => {
    if (!courseName || !postureCount) {
      toast.error('Course name and Asana count required.');
      return;
    }

    // const updatedCourse = {
    //   id: courseData.courseId,
    //   courseName,
    //   asanaCount: Number(postureCount),
    //   difficulty,
    //   category,
    //   description,
    //   // tags: tags.split(',').map((tag) => tag.trim()),
    //   // tags: tags ? tags.split(',').map(tag => tag.trim()) : [],
    //   // sequenceType,
    //   // courseId: courseData.courseId

    //   tags: tags
    // ? tags.split(',').map((tag) => tag.trim()).filter((tag) => tag.length > 0)
    // : [],
    // };
    
      const updatedCourse = {
      courseId: courseData.courseId || courseData.id, // ✅ id -> courseId
      courseName,
      asanaCount: Number(postureCount),
      difficulty,
      category,
      description,
      tags: tags ? tags.split(',').map(tag => tag.trim()) : [], // ✅ parse comma separated string
      sequenceType: sequenceType || '', // ✅ make sure sequenceType included
      };

    mutate(updatedCourse);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <Box sx={{ padding: 0, maxWidth: 500 }}>
          <TextField label="Course Name" fullWidth sx={{ mb: 2 }} value={courseName} onChange={(e) => setCourseName(e.target.value)} />
          <TextField
            label="Number of Postures"
            fullWidth
            type="number"
            sx={{ mb: 2 }}
            value={postureCount}
            onChange={(e) => setPostureCount(e.target.value)}
          />

          <TextField
            select
            SelectProps={{ native: true }}
            fullWidth
            label="Difficulty"
            sx={{ mb: 2 }}
            value={difficulty}
            onChange={(e) => setDifficulty(e.target.value)}
          >
            <option value="">Select Difficulty</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
          </TextField>

          <TextField label="Category" fullWidth sx={{ mb: 2 }} value={category} onChange={(e) => setCategory(e.target.value)} />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            sx={{ mb: 2 }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField label="Tags (comma separated)" fullWidth sx={{ mb: 2 }} value={tags} onChange={(e) => setTags(e.target.value)} />

          <TextField
            select
            SelectProps={{ native: true }}
            fullWidth
            label="Sequence Type"
            sx={{ mb: 2 }}
            value={sequenceType}
            onChange={(e) => setSequenceType(e.target.value)}
          >
            <option value="">Select Sequence</option>
            <option value="standalone">Stand Alone</option>
            <option value="continuous">Continuous</option>
          </TextField>

          <DialogActions>
            <Button onClick={handleSubmit} variant="contained" disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Update'}
            </Button>
            <Button onClick={onClose} variant="outlined">
              Cancel
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EditCourseDialogue;
